/*
 * @author Charles Xie
 */

import {ElectronicComponent} from "./ElectronicComponent";

export class CheckBox implements ElectronicComponent {

  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  on: boolean = false;

  constructor(name: string, x: number, y: number, width: number, height: number) {
    this.name = name;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  public isSelected(): boolean {
    return this.on;
  }

  public draw(ctx: CanvasRenderingContext2D) {
    // draw slot
    ctx.fillStyle = 'gray';
    ctx.fillRect(this.x, this.y, this.width, this.height);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'black';
    ctx.rect(this.x, this.y, this.width, this.height);
    ctx.stroke();
    // draw thumb
    ctx.fillStyle = 'white';
    if (this.on) {
      ctx.fillRect(this.x + this.width / 2 + 1, this.y + 1, this.width / 2 - 2, this.height - 2);
      ctx.rect(this.x + this.width / 2 + 1, this.y + 1, this.width / 2 - 2, this.height - 2);
    } else {
      ctx.fillRect(this.x + 1, this.y + 1, this.width / 2 - 2, this.height - 2);
      ctx.rect(this.x + 1, this.y + 1, this.width / 2 - 2, this.height - 2);
    }
  }

  public contains(x: number, y: number): boolean {
    return x > this.x && x < this.x + this.width && y > this.y && y < this.y + this.height;
  }

}
